module OnlineDPR.Application.Client.Http

open Fable.Core
open Fetch
open Thoth.Json

let errorString (response: Response) =
    string response.Status + " " + response.StatusText + " for URL " + response.Url

let fetchWithDecoder<'T> (url: string) (decoder: Decoder<'T>) (init: RequestProperties list) =
    GlobalFetch.fetch(RequestInfo.Url url, Fetch.requestProps init)
    |> Promise.bind (fun response ->
        if not response.Ok then
            errorString response |> Error |> Promise.lift
        else
            response.text() |> Promise.map (Decode.fromString decoder))

let inline fetchAs<'a> (url: string) (init: RequestProperties list) =
    let decoder = Decode.Auto.generateDecoderCached<'a>(extra = Encoders.extra)
    fetchWithDecoder url decoder init

let inline postData<'a> url data =
    let jsonString = Encode.Auto.toString(0, data, extra = Encoders.extra)
    let bodyInit = U2.Case2 (jsonString)

    let props = [ RequestProperties.Method HttpMethod.POST
                  requestHeaders [ContentType "application/json"]
                  RequestProperties.Body bodyInit
                  Credentials RequestCredentials.Include ]
    fetchAs<'a> url props

let inline getData<'a> url =
    let props = [ RequestProperties.Method HttpMethod.GET
                  requestHeaders [ContentType "application/json"]
                  Credentials RequestCredentials.Include ]
    fetchAs<'a> url props

let inline toErrorMessage e =
    Error (string e)